import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {BaseOnDestroyComponent} from '../../../shared/injectables/BaseOnDestroy.component';
import {Product} from '../../models';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {ApplicationState} from '../../../application-state/store';
import {distinctUntilChanged, filter, map, takeUntil} from 'rxjs/operators';
import {ProductsSelectors} from '../../store/selectors';
import {loadIfNotLoaded} from '../../../shared/utilities/observable.utility';
import {ProductsActions} from '../../store';
import {extractIri} from '../../../shared/utilities/objects.utility';

@Component({
  selector: 'app-product-select',
  styleUrls: ['./product-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ProductSelectComponent),
    multi: true
  }],
  template: `
    <div [formGroup]="form" class="mat-form-field">

      <ng-select
        [class.required]="required"
        formControlName="selectedElement"
        [items]="items$|async"
        bindLabel="name"
        [searchable]="true"
        [loading]="isLoading$| async"
        bindValue="@id"
        [clearable]="true"
        [searchFn]="findItem"
        (change)="setSelectedItem($event)"
        [required]="required"
        (touchstart)="onTouched($event)"
        placeholder="Produkt">

        <ng-template ng-label-tmp let-item="item">
          {{item.name}}

        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          {{item.name}}
        </ng-template>
      </ng-select>
      <mat-error>
        <app-form-error fieldName="selectedElement" [formGroup]="form"></app-form-error>
      </mat-error>

    </div>

  `
})
export class ProductSelectComponent extends BaseOnDestroyComponent implements OnInit, ControlValueAccessor {
  form: FormGroup;
  @Output() updateSelectedObject: EventEmitter<Product> = new EventEmitter<Product>();
  @Input() required = false;

  items$: Observable<Array<Product>>;
  isLoading$: Observable<boolean>;
  selectedItem: Product;
  onChange: any = () => {
  }
  onTouched: any = () => {
  }

  constructor(
    private store$: Store<ApplicationState>,
    private fb: FormBuilder,
  ) {
    super();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      selectedElement: this.fb.control(null),
    });
    this.form.get('selectedElement').valueChanges.pipe(takeUntil(this.onDestroy$), distinctUntilChanged()).subscribe(value => {
      this.onChange(value);
    });
    this.items$ = this.store$.select(ProductsSelectors.sList);
    this.isLoading$ = this.store$.select(ProductsSelectors.isLoading);
    loadIfNotLoaded(this.store$, ProductsSelectors.isLoaded, ProductsActions.ReadProducts());
  }

  setSelectedItem(element: Product): void {
    this.selectedItem = element;
    this.updateSelectedObject.emit(element);
  }

  findItem(term: string, item: Product): boolean {
    const parts = term.split(' ');
    return parts.every(t => {
      return (item.name.toLowerCase().indexOf(t.toLowerCase()) > -1);
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;

  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.get('selectedElement').disable();
    } else {
      this.form.get('selectedElement').enable();
    }
  }

  writeValue(value: any): void {
    this.form.get('selectedElement').setValue(extractIri(value));
    this.items$.pipe(takeUntil(this.onDestroy$), map(e => e.find(e => extractIri(e) === extractIri(value))), filter(e => !!e))
      .subscribe((element) => {
        this.setSelectedItem(element);
      });
  }

}
